import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../../shared/services/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorStore } from '../../shared/components/form-validation-errors/error.store';

export const fetchErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const translate = inject(TranslateService);
  const errorStore = inject(ErrorStore);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 500:
          toastService.error(translate.instant('app.errors.server'));
          break;
        case 429:
          toastService.warn(translate.instant('app.errors.too_many_attempts'));
          break;
        case 422:
          // toastService.warn(translate.instant('app.errors.validation_error'));
          errorStore.setValidationErrors(error.error.errors);
          break;
        case 404:
          // toastService.warn(translate.instant('app.errors.not_found'));
          break;
        default:
          break;
      }

      return throwError(() => error);
    })
  );
};
